[
    {
        "category": "Obtain Second Pair of Eyes (SPOE)",
        "items": [
            "Underwriting Submission",
            "Draft Contract Wording",
            "Quotes \/ Revised Quotes",
            "Firm Order Contract",
            "Authorization \/ Revised Authorization",
            "Suggested Signed Lines",
            "Final Contract Wording",
            "All Interest & Liabilities"
        ]
    },
    {
        "category": "INCLUDE GRe NA TEMPLATE TEXT",
        "items": [
            "Underwriting Submission to Reinsurers",
            "Draft Contract Wording to Reinsurers",
            "Quotes to Client",
            "Firm Order Acknowledgement to Client",
            "Authorizations \/ Suggested Signed Lines to Client",
            "Non-Concurrent Terms to Client",
            "Final Contracts to Client",
            "Final Signed Lines, Contracts and I&Ls to Reinsurers"
        ]
    },
    {
        "category": "Obtain Client Approval",
        "items": [
            "Any \/ All Markets Utilized",
            "Underwriting Submission",
            "Draft Contract Wording",
            "Firm Order Term and\/or Firm Order Contracts",
            "Suggested \/ Final Signed Lines",
            "Non-Concurrent Terms",
            "Incomplete Placement Status",
            "Final Contract Wording"
        ]
    },
    {
        "category": "Obtain Client Signature",
        "items": [
            "BOR Letter",
            "RIAA Letter",
            "Any \/ All Other Legal Agreements",
            "Client Instruction Letter - Not Approved Markets",
            "Client Direction Letter - Collateralized Markets",
            "Final Contract Wording"
        ]
    }
]